import domClassNames from '../consts/domClassNames';

const getElementBySelector = (selector) => document.querySelector(selector);

const getComponentsWrapperElement = () => getElementBySelector(`.${domClassNames.APP_CONTAINER_CLASSNAME}`);

export default {
    getComponentsWrapperElement,
    getElementBySelector,
};
